import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentCtn: {
    backgroundColor: '#fff',
    borderRadius: 30,
    height: 'auto',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  modaIconContainer: {
    position: 'absolute',
    top: -30,
    zIndex: 100,
    borderRadius: 35,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    width: 70,
    height: 70,
    backgroundColor: 'green',
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    padding: 5,
  },
  title: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '500',
    marginTop: 34,
  },
  childrenCtn: {
    paddingHorizontal: 12,
    marginVertical: 16,
  },
  close: {
    marginHorizontal: 10,
    marginTop: 4,
  },
  btnContainerSmall: {
    width: '80%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: '2%',
    borderRadius: 4,
  },
  btnPrintTitle: {
    color: '#000000',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  printBtn: {
    backgroundColor: 'transparent',
    borderWidth: 1,
  },
  buttonContainer: {
    marginTop: 1,
  },
  buttonContainerMedium: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  btnContainerLarge: {
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
    marginBottom: '5%',
    borderRadius: 4,
  },
});
